import { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import * as api from '../lib/api/api';
import * as PATH from '../lib/routes/path';
import { isProductionEnv } from '../lib/util/Environment';
import ImageFileContext from '../modules/contexts/ImageFile';
import { useAnalytics } from './useAnalytics';

export const useCompletion = (id) => {
  const {
    actions: { setUltraList, setUltraPreviewList },
  } = useContext(ImageFileContext);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [ultrasoundInfo, setUltrasoundInfo] = useState(null);
  const history = useHistory();

  const { gaEnhancedEcommerce, onNaverAnalytics } = useAnalytics();

  useEffect(() => {
    document.body.style.overscrollBehaviorY = 'none';

    return () => {
      document.body.style.overscrollBehaviorY = 'auto';
    };
  }, []);

  useEffect(() => {
    getPaymentInfo();
  }, []);

  const getPaymentInfo = () => {
    api.getPaymentInfo(id).then((response) => {
      const data = response.data;
      setPaymentInfo(data);
      setUltraList([]);
      setUltraPreviewList([]);

      if (!data.items[0].voucher) {
        getUltrasoundInfo(data.items[0].id);
      }

      if (isProductionEnv) {
        gaEnhancedEcommerce({ data, isPurchase: true });
        onNaverAnalytics({ data });
      }
    });
  };

  const getUltrasoundInfo = (itemId) => {
    api.getUltrasound({ itemId }).then((res) => {
      setUltrasoundInfo(res.data);
    });
  };

  const LinkToPath = (path) => history.push(path);

  const linkToOrderDetail = () =>
    LinkToPath(`${PATH.MYPAGE_ORDER_DETAIL}/${paymentInfo.id}`);

  return { ultrasoundInfo, paymentInfo, linkToOrderDetail, LinkToPath };
};
